import React from "react";
import "./styles/MessageMailDelete.css";

export default function MessageMailDelete() {
  return (
    <div className="tiltemessagedelete">
      <h1 className="tilte-message-delete"> Mail envoyé ! </h1>
    </div>
  );
}
